import { render, staticRenderFns } from "./SolicitudWrapper.vue?vue&type=template&id=d451f1ee"
import script from "./SolicitudWrapper.vue?vue&type=script&lang=js"
export * from "./SolicitudWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports